import CircularProgress from '@material-ui/core/CircularProgress'
import React from 'react'

const ContentLoader = () => (
  <div className="iron-progress-bar d-flex justify-content-center align-items-center">
    <CircularProgress size={70} thickness={1.5} />
  </div>
)

export default ContentLoader
